import { ReferralCopy } from '@/components/_referrals/ReferralCopy'
import AccountMenuItems from './AccountMenuItems'
import AccountMenuStoreCredit from './AccountMenuStoreCredit'
import AccountTitle from './AccountTitle'
import QuickLinks from './QuickLinks'

const AccountMenu = ({
  isAccountPopover = false,
}: {
  isAccountPopover?: boolean
}) => (
  <div>
    <AccountTitle isAccountPopover={isAccountPopover} />
    <QuickLinks isAccountPopover={isAccountPopover} />
    <ReferralCopy isAccountPopover={isAccountPopover} isAccountMenu />
    <AccountMenuStoreCredit />
    <AccountMenuItems isAccountPopover={isAccountPopover} />
  </div>
)

export default AccountMenu
